export const CDN_NODES = 700
export const IMAGEKIT_PROCESSING_REGION_COUNT = 6
export const TOTAL_COUNTRIES = "80"
export const DEVELOPER_COUNT = "250K";
export const PAID_CUSTOMERS = "2,000"
export const TOTAL_USERS = "250,000"
